import React from 'react';

import { useSelector } from 'react-redux';
import { Route } from 'react-router';

import ErrorScreen from 'components/shared/ErrorScreen';
import { isSuperAdminSelector } from 'store/user/selectors';

function SuperAdminRoute({ component: Component, hasAccess = true, ...rest }) {
  const isSuperAdmin = useSelector(isSuperAdminSelector);

  return (
    <Route
      {...rest}
      render={(props) => {
        return isSuperAdmin && hasAccess ? <Component {...props} /> : <ErrorScreen status="403" />;
      }}
    />
  );
}

export default SuperAdminRoute;
